import { render, staticRenderFns } from "./messagesAdd.vue?vue&type=template&id=7e377048"
import script from "./messagesAdd.vue?vue&type=script&lang=js"
export * from "./messagesAdd.vue?vue&type=script&lang=js"
import style0 from "./messagesAdd.vue?vue&type=style&index=0&id=7e377048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports